import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 仪表盘面板
 *
 * 管理员中心默认展示的 Dashboard section 内容。
 */
import * as React from 'react';
import { UsersIcon, StatsIcon, SettingsIcon, ShieldIcon } from './icons.js';
/** 仪表盘面板组件 */
export function DashboardPanel() {
    return (_jsxs("div", { style: styles.panel, children: [_jsxs("div", { style: styles.header, children: [_jsx("h1", { style: styles.title, children: "\u7BA1\u7406\u4EEA\u8868\u76D8" }), _jsx("p", { style: styles.subtitle, children: "\u7CFB\u7EDF\u8FD0\u884C\u72B6\u6001\u6982\u89C8" })] }), _jsxs("div", { style: styles.statsGrid, children: [_jsx(StatCard, { icon: React.createElement(UsersIcon), label: "\u7528\u6237\u603B\u6570", value: "1,234", change: "+12%", color: "#6366f1" }), _jsx(StatCard, { icon: React.createElement(StatsIcon), label: "\u65E5\u6D3B\u8DC3\u7528\u6237", value: "567", change: "+5%", color: "#10b981" }), _jsx(StatCard, { icon: React.createElement(ShieldIcon), label: "\u5B89\u5168\u4E8B\u4EF6", value: "0", change: "\u7A33\u5B9A", color: "#f59e0b" }), _jsx(StatCard, { icon: React.createElement(SettingsIcon), label: "\u7CFB\u7EDF\u8D1F\u8F7D", value: "23%", change: "\u6B63\u5E38", color: "#3b82f6" })] }), _jsxs("div", { style: styles.section, children: [_jsx("h3", { style: styles.sectionTitle, children: "\u26A1 \u5FEB\u6377\u64CD\u4F5C" }), _jsxs("div", { style: styles.actionGrid, children: [_jsx(ActionCard, { icon: React.createElement(UsersIcon), title: "\u7528\u6237\u7BA1\u7406", description: "\u67E5\u770B\u548C\u7BA1\u7406\u7CFB\u7EDF\u7528\u6237", color: "#6366f1" }), _jsx(ActionCard, { icon: React.createElement(ShieldIcon), title: "\u5B89\u5168\u5BA1\u8BA1", description: "\u67E5\u770B\u5B89\u5168\u65E5\u5FD7\u548C\u5BA1\u8BA1\u8BB0\u5F55", color: "#10b981" }), _jsx(ActionCard, { icon: React.createElement(SettingsIcon), title: "\u7CFB\u7EDF\u8BBE\u7F6E", description: "\u914D\u7F6E\u7CFB\u7EDF\u53C2\u6570\u548C\u9009\u9879", color: "#f59e0b" }), _jsx(ActionCard, { icon: React.createElement(StatsIcon), title: "\u6570\u636E\u62A5\u8868", description: "\u67E5\u770B\u7EDF\u8BA1\u6570\u636E\u548C\u62A5\u8868", color: "#3b82f6" })] })] }), _jsxs("div", { style: styles.section, children: [_jsx("h3", { style: styles.sectionTitle, children: "\uD83D\uDCCB \u6700\u8FD1\u6D3B\u52A8" }), _jsxs("div", { style: styles.activityList, children: [_jsx(ActivityItem, { time: "10:30", text: "\u7528\u6237 admin \u767B\u5F55\u7CFB\u7EDF" }), _jsx(ActivityItem, { time: "09:15", text: "\u7CFB\u7EDF\u5907\u4EFD\u5DF2\u5B8C\u6210" }), _jsx(ActivityItem, { time: "08:00", text: "\u65B0\u7528\u6237\u6CE8\u518C: user123" }), _jsx(ActivityItem, { time: "\u6628\u5929", text: "\u5B89\u5168\u626B\u63CF\u5B8C\u6210\uFF0C\u65E0\u5F02\u5E38" })] })] })] }));
}
/** 统计卡片组件 */
function StatCard({ icon, label, value, change, color }) {
    const [hovered, setHovered] = React.useState(false);
    return React.createElement('div', {
        style: {
            ...styles.statCard,
            boxShadow: hovered ? `0 8px 24px ${color}22` : '0 2px 8px rgba(0,0,0,0.08)',
            transform: hovered ? 'translateY(-2px)' : 'none',
        },
        onMouseEnter: () => setHovered(true),
        onMouseLeave: () => setHovered(false),
    }, React.createElement('div', { style: { ...styles.statIcon, backgroundColor: `${color}15`, color } }, icon), React.createElement('div', { style: styles.statContent }, React.createElement('span', { style: styles.statLabel }, label), React.createElement('span', { style: styles.statValue }, value), React.createElement('span', { style: { ...styles.statChange, color } }, change)));
}
/** 快捷操作卡片组件 */
function ActionCard({ icon, title, description, color }) {
    const [hover, setHover] = React.useState(false);
    return React.createElement('div', {
        style: {
            ...styles.actionCard,
            borderColor: hover ? color : '#e5e7eb',
            boxShadow: hover ? `0 4px 12px ${color}22` : 'none',
        },
        onMouseEnter: () => setHover(true),
        onMouseLeave: () => setHover(false),
    }, React.createElement('div', { style: { ...styles.actionIcon, backgroundColor: `${color}15`, color } }, icon), React.createElement('div', { style: styles.actionText }, React.createElement('span', { style: styles.actionTitle }, title), React.createElement('span', { style: styles.actionDesc }, description)));
}
/** 活动条目组件 */
function ActivityItem({ time, text }) {
    return React.createElement('div', { style: styles.activityItem }, React.createElement('span', { style: styles.activityTime }, time), React.createElement('span', { style: styles.activityDot }), React.createElement('span', { style: styles.activityText }, text));
}
const styles = {
    panel: {
        maxWidth: '900px',
        margin: '0 auto',
        padding: '32px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    header: {
        marginBottom: '32px',
    },
    title: {
        margin: '0 0 8px 0',
        fontSize: '28px',
        fontWeight: 700,
        color: '#1e293b',
    },
    subtitle: {
        margin: 0,
        fontSize: '14px',
        color: '#64748b',
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '16px',
        marginBottom: '32px',
    },
    statCard: {
        padding: '20px',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        border: '1px solid #e5e7eb',
        transition: 'all 0.2s ease',
        cursor: 'default',
    },
    statIcon: {
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '12px',
    },
    statContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },
    statLabel: {
        fontSize: '12px',
        color: '#64748b',
        fontWeight: 500,
    },
    statValue: {
        fontSize: '24px',
        fontWeight: 700,
        color: '#1e293b',
    },
    statChange: {
        fontSize: '12px',
        fontWeight: 600,
    },
    section: {
        marginBottom: '32px',
    },
    sectionTitle: {
        fontSize: '16px',
        fontWeight: 600,
        color: '#1e293b',
        margin: '0 0 16px 0',
    },
    actionGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '12px',
    },
    actionCard: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '16px',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        border: '1px solid #e5e7eb',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
    },
    actionIcon: {
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    actionText: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
    },
    actionTitle: {
        fontSize: '14px',
        fontWeight: 600,
        color: '#1f2937',
    },
    actionDesc: {
        fontSize: '12px',
        color: '#9ca3af',
    },
    activityList: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        padding: '16px',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        border: '1px solid #e5e7eb',
    },
    activityItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '8px 0',
        borderBottom: '1px solid #f3f4f6',
    },
    activityTime: {
        fontSize: '12px',
        color: '#9ca3af',
        fontWeight: 500,
        minWidth: '60px',
    },
    activityDot: {
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        backgroundColor: '#6366f1',
        flexShrink: 0,
    },
    activityText: {
        fontSize: '14px',
        color: '#374151',
    },
};
//# sourceMappingURL=dashboard-panel.js.map